import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiGet, apiPost } from "../api/api";

export default function InventarioDetalhes() {
  const { id } = useParams();

  const [inventario, setInventario] = useState(null);
  const [molduras, setMolduras] = useState([]);
  const [formatos, setFormatos] = useState([]);

  // Criar moldura
  const [novoLadoVia, setNovoLadoVia] = useState("");
  const [novaDescricao, setNovaDescricao] = useState("");
  const [novoFormato, setNovoFormato] = useState("");
  const [tipoMoldura, setTipoMoldura] = useState("COMERCIAL");

  // Criar face
  const [novoLado, setNovoLado] = useState({});
  const [novaFaceIdentificador, setNovaFaceIdentificador] = useState({});

  // Uploads
  const [fotoMoldura, setFotoMoldura] = useState({});
  const [fotoFace, setFotoFace] = useState({});

  // Registo de campanha (por face)
  const [campanhaMarca, setCampanhaMarca] = useState({});
  const [campanhaNome, setCampanhaNome] = useState({});
  const [campanhaObs, setCampanhaObs] = useState({});
  const [campanhaFoto, setCampanhaFoto] = useState({});
  const [marcasSugeridas, setMarcasSugeridas] = useState([]);
  const [campanhasSugeridas, setCampanhasSugeridas] = useState([]);
  const [ultimasCampanhas, setUltimasCampanhas] = useState({});

  // ============================
  // Carregar Inventário + Molduras
  // ============================
  async function load() {
    const inv = await apiGet(`/inventario/${id}`);
    setInventario(inv);

    const md = await apiGet(`/molduras/inventario/${id}`);
    setMolduras(md);

    // EXTRAIR TODAS AS FACES
    const todasAsFaces = md.flatMap((m) => m.faces || []);
    await carregarUltimasCampanhas(todasAsFaces);
  }

  useEffect(() => {
    load();
  }, []);

  // ============================
  // Carregar Formatos
  // ============================
  useEffect(() => {
    async function loadFormatos() {
      const data = await apiGet("/formatos/");
      setFormatos(data);
    }
    loadFormatos();
  }, []);

  // ============================
  // Carregar marcas nomes campanhas
  // ============================
  useEffect(() => {
    async function loadSugestoes() {
      const marcas = await apiGet("/campanhas/marcas");
      const campanhas = await apiGet("/campanhas/nomes");

      setMarcasSugeridas(marcas);
      setCampanhasSugeridas(campanhas);
    }
    loadSugestoes();
  }, []);

  // ============================
  // Criar Moldura
  // ============================
  async function criarMoldura() {
    if (!novoLadoVia) {
      alert("Selecione o lado da via.");
      return;
    }

    await apiPost(`/molduras/inventario/${id}`, {
      lado_via: novoLadoVia,
      descricao: novaDescricao,
      formato: novoFormato,
      tipo_moldura: tipoMoldura,
    });

    setNovoLadoVia("");
    setNovaDescricao("");
    setNovoFormato("");
    setTipoMoldura("COMERCIAL");
    load();
  }

  // ============================
  // Criar Face
  // ============================
  async function criarFace(molduraId) {
    await apiPost(`/faces/moldura/${molduraId}`, {
      lado: novoLado[molduraId],
      identificador: novaFaceIdentificador[molduraId],
      estado: "ativa",
    });

    setNovoLado({ ...novoLado, [molduraId]: "" });
    setNovaFaceIdentificador({ ...novaFaceIdentificador, [molduraId]: "" });
    load();
  }

  // ============================
  // Apagar Moldura
  // ============================
  async function apagarMoldura(molduraId) {
    if (!window.confirm("Apagar moldura?")) return;

    await fetch(`/api/molduras/${molduraId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    load();
  }

  // ============================
  // Alterar Tipo Moldura
  // ============================
  async function alterarTipoMoldura(molduraId, novoTipo) {
    await fetch(`/api/molduras/${molduraId}?tipo_moldura=${novoTipo}`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    load();
  }

  // ============================
  // Apagar Face
  // ============================
  async function apagarFace(faceId) {
    if (!window.confirm("Apagar face?")) return;

    await fetch(`/api/faces/${faceId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    load();
  }

  // ============================
  // Upload Foto Moldura
  // ============================
  async function enviarFotoMoldura(molduraId) {
    if (!fotoMoldura[molduraId]) return alert("Selecione uma foto primeiro.");

    const form = new FormData();
    form.append("file", fotoMoldura[molduraId]);

    await fetch(`/api/molduras/${molduraId}/foto`, {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: form,
    });

    load();
  }

  // ============================
  // Upload Foto Face
  // ============================
  async function enviarFotoFace(faceId) {
    if (!fotoFace[faceId]) return alert("Selecione uma foto primeiro.");

    const form = new FormData();
    form.append("file", fotoFace[faceId]);

    await fetch(`/api/faces/${faceId}/foto`, {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: form,
    });

    load();
  }

  // ============================
  // Registar campanha
  // ============================
  async function registarCampanha(faceId) {
    const form = new FormData();

    form.append("marca", campanhaMarca[faceId] || "");
    form.append("campanha", campanhaNome[faceId] || "");
    form.append("obs", campanhaObs[faceId] || "");

    if (campanhaFoto[faceId]) {
      form.append("file", campanhaFoto[faceId]);
    }

    const res = await fetch(`/api/campanhas/face/${faceId}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: form,
    });

    if (!res.ok) {
      const txt = await res.text();
      alert("Erro ao registar campanha: " + txt);
      return;
    }

    // Atualizar sugestões
    const marcas = await apiGet("/campanhas/marcas");
    const campanhas = await apiGet("/campanhas/nomes");
    setMarcasSugeridas(marcas);
    setCampanhasSugeridas(campanhas);

    // Limpar campos
    setCampanhaFoto((prev) => ({ ...prev, [faceId]: null }));
    setCampanhaMarca((prev) => ({ ...prev, [faceId]: "" }));
    setCampanhaNome((prev) => ({ ...prev, [faceId]: "" }));
    setCampanhaObs((prev) => ({ ...prev, [faceId]: "" }));

    alert("Campanha registada com sucesso 📸");
    load();
  }

  async function carregarUltimasCampanhas(faces) {
    const resultado = {};

    for (const face of faces) {
      try {
        const data = await apiGet(`/campanhas/face/${face.id}/ultimos`);
        resultado[face.id] = data;
      } catch (e) {
        resultado[face.id] = [];
      }
    }

    setUltimasCampanhas(resultado);
  }

  if (!inventario) return <div>Carregando...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h1>Inventário #{inventario.id}</h1>

      <p>
        <strong>Tipo Localização:</strong> {inventario.tipo_localizacao}
      </p>
      <p>
        <strong>Operador:</strong> {inventario.operador?.nome}
      </p>

      <hr />

      {/* ============================
          Criar Moldura
      ============================ */}
      <h2>Adicionar Moldura</h2>

      <select value={novoLadoVia} onChange={(e) => setNovoLadoVia(e.target.value)}>
        <option value="">-- Lado Via --</option>
        <option value="DIREITA">DIREITA</option>
        <option value="ESQUERDA">ESQUERDA</option>
        <option value="CENTRO">CENTRO</option>
      </select>

      <input
        placeholder="Descrição"
        value={novaDescricao}
        onChange={(e) => setNovaDescricao(e.target.value)}
        style={{ marginLeft: 10 }}
      />

      <select
        value={novoFormato}
        onChange={(e) => setNovoFormato(e.target.value)}
        style={{ marginLeft: 10 }}
      >
        <option value="">-- Formato --</option>
        {formatos.map((f) => (
          <option key={f.id} value={f.nome}>
            {f.nome}
          </option>
        ))}
      </select>

      <select
        value={tipoMoldura}
        onChange={(e) => setTipoMoldura(e.target.value)}
        style={{ marginLeft: 10 }}
      >
        <option value="COMERCIAL">📢 Comercial</option>
        <option value="INSTITUCIONAL">🏛️ Institucional</option>
      </select>

      <button onClick={criarMoldura} style={{ marginLeft: 10 }}>
        Criar Moldura
      </button>

      <hr />

      {/* ============================
          Lista de Molduras
      ============================ */}
      <h2>Molduras</h2>

      {molduras.map((m) => (
        <div
          key={m.id}
          style={{ padding: 15, border: "1px solid #ccc", marginBottom: 10 }}
        >
          <h3>Moldura #{m.id}</h3>

          {m.foto_path && (
            <img
              src={m.foto_path}
              alt="foto moldura"
              style={{
                width: 120,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                border: "1px solid #aaa",
                marginBottom: 10,
              }}
            />
          )}

          <p>
            <strong>Lado Via:</strong> {m.lado_via}
          </p>
          <p>
            <strong>Descrição:</strong> {m.descricao}
          </p>
          <p>
            <strong>Formato:</strong> {m.formato}
          </p>
          <p>
            <strong>Tipo:</strong>{" "}
            {m.tipo_moldura === "INSTITUCIONAL" ? "🏛️ Institucional" : "📢 Comercial"}
          </p>

          <button
            onClick={() =>
              alterarTipoMoldura(
                m.id,
                m.tipo_moldura === "COMERCIAL" ? "INSTITUCIONAL" : "COMERCIAL"
              )
            }
            style={{
              marginBottom: 10,
              background: "#1976d2",
              color: "white",
              padding: "4px 8px",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            🔁 Tornar {m.tipo_moldura === "COMERCIAL" ? "Institucional" : "Comercial"}
          </button>

          {/* Upload foto moldura */}
          <div style={{ marginBottom: 10 }}>
            <input
              type="file"
              onChange={(e) =>
                setFotoMoldura({ ...fotoMoldura, [m.id]: e.target.files[0] })
              }
            />
            <button onClick={() => enviarFotoMoldura(m.id)} style={{ marginLeft: 5 }}>
              Enviar Foto
            </button>

            <button
              onClick={() => apagarMoldura(m.id)}
              style={{ background: "red", color: "white", marginLeft: 10 }}
            >
              Apagar Moldura
            </button>
          </div>

          {/* Faces */}
          <h4>Adicionar Face</h4>

          <input
            placeholder="Lado"
            value={novoLado[m.id] || ""}
            onChange={(e) => setNovoLado({ ...novoLado, [m.id]: e.target.value })}
          />

          <input
            placeholder="Identificador"
            value={novaFaceIdentificador[m.id] || ""}
            onChange={(e) =>
              setNovaFaceIdentificador({
                ...novaFaceIdentificador,
                [m.id]: e.target.value,
              })
            }
            style={{ marginLeft: 10 }}
          />

          <button onClick={() => criarFace(m.id)} style={{ marginLeft: 10 }}>
            Criar Face
          </button>

          <h4 style={{ marginTop: 15 }}>Faces</h4>

          {m.faces?.map((f) => (
            <div key={f.id} style={{ marginBottom: 10 }}>
              {f.foto_path && (
                <img
                  src={f.foto_path}
                  alt="foto face"
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "cover",
                    borderRadius: 6,
                    border: "1px solid #aaa",
                    marginRight: 10,
                  }}
                />
              )}

              <h4
                style={{
                  margin: "5px 0",
                  padding: "4px 8px",
                  background: "#e3f2fd",
                  borderRadius: 4,
                  display: "inline-block",
                }}
              >
                Face #{f.id}
              </h4>

              <div style={{ marginBottom: 5 }}>
                <strong>
                  {f.lado} — {f.identificador}
                </strong>
              </div>

              <input
                type="file"
                style={{ marginLeft: 10 }}
                onChange={(e) => setFotoFace({ ...fotoFace, [f.id]: e.target.files[0] })}
              />
              <button onClick={() => enviarFotoFace(f.id)}>Enviar Foto</button>

              <button
                onClick={() => apagarFace(f.id)}
                style={{
                  marginLeft: 10,
                  background: "#c62828",
                  color: "white",
                  padding: "3px 7px",
                }}
              >
                Apagar
              </button>

              <hr style={{ margin: "10px 0" }} />

              {ultimasCampanhas[f.id]?.length > 0 && (
                <div style={{ background: "#f5f5f5", padding: 10, borderRadius: 6 }}>
                  <strong>Últimos registos:</strong>
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {ultimasCampanhas[f.id].map((c) => (
                      <li key={c.id}>
                        {new Date(c.data_registo).toLocaleDateString()} —{" "}
                        <strong>{c.marca}</strong> | {c.campanha}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* ✅ REGISTAR CAMPANHA APENAS SE MOLDURA FOR COMERCIAL */}
              {m.tipo_moldura === "COMERCIAL" && (
                <div>
                  <h5>📸 Registar Campanha</h5>

                  <input
                    list="lista-marcas"
                    placeholder="Marca"
                    value={campanhaMarca[f.id] || ""}
                    onChange={(e) =>
                      setCampanhaMarca({ ...campanhaMarca, [f.id]: e.target.value })
                    }
                  />

                  <input
                    list="lista-campanhas"
                    placeholder="Campanha"
                    value={campanhaNome[f.id] || ""}
                    onChange={(e) =>
                      setCampanhaNome({ ...campanhaNome, [f.id]: e.target.value })
                    }
                  />

                  <input
                    placeholder="Observações"
                    value={campanhaObs[f.id] || ""}
                    onChange={(e) =>
                      setCampanhaObs({ ...campanhaObs, [f.id]: e.target.value })
                    }
                  />

                  <input
                    type="file"
                    onChange={(e) =>
                      setCampanhaFoto({ ...campanhaFoto, [f.id]: e.target.files[0] })
                    }
                  />

                  <button
                    onClick={() => registarCampanha(f.id)}
                    style={{
                      marginTop: 5,
                      background: "#2e7d32",
                      color: "white",
                      padding: "5px 10px",
                      border: "none",
                      borderRadius: 4,
                    }}
                  >
                    Guardar Campanha
                  </button>
                </div>
              )}

            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
